import React from 'react';
import { useUser } from 'store/User/Context';

import { HeaderStyle, LegendList, SectionBox } from 'components/analysis/AnalysisSaleList';
import BarWrapper from 'components/common/BarWrapper';

interface TimeRangeTotalPriceBarsProps {
    totalPriceByTime: { name: string; bar1: number; bar2: number; }[];
}

export const TimeRangeTotalPriceBars = ({ totalPriceByTime }: TimeRangeTotalPriceBarsProps) => {
    const { user } = useUser();

    return (
        <SectionBox data-pdf-section>
            <HeaderStyle>
                <h2>Cena całkowita według przedziałów czasu</h2>
                <LegendList darkMode={user.isDarkMode}>
                    <li>Średnia cena całkowita brutto [PLN]</li>
                    <li>Mediana ceny całkowitej brutto [PLN]</li>
                </LegendList>
                <BarWrapper className="total-price-time" barData={totalPriceByTime}/>
            </HeaderStyle>
        </SectionBox>
    );
};
